import { connect } from 'react-redux'
import { setModal } from 'actions/account'

const mapStateToProps = () => ({})
const actions = { setModal }

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
